import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, Input } from '@angular/core';
import { HiringService } from 'src/app/pages/hiring/services/hiring.service';

@Component({
  selector: 'app-delete-onboard-employee-modal',
  templateUrl: './delete-onboard-employee-modal.component.html',
  styleUrls: ['./delete-onboard-employee-modal.component.css']
})
export class DeleteOnboardEmployeeModalComponent {
  @Input() data: any;
  processing: boolean= false;
  alert: any;

  constructor(public activeModal: NgbActiveModal, private modalService: NgbModal, private hiringService: HiringService) {
  }

  deleteClick() {
    this.processing = true;
    this.hiringService.deleteOnboarding(this.data.OnboardID).then((response: any) => {
      if (response.success)
        this.activeModal.close("delete");
      else
        this.alert = ({ type: "danger", msg: "There were errors deleting the employee." });
    });
  }

  closeClick() {
    this.activeModal.dismiss();
  }
 
}